import { Box, Typography } from '@mui/material';

type SummaryBoxProps = {
  label: string;
  value: number;
  color?: string;
  decimals?: number;
  suffix?: string;
};

export const SANDBOX_BACKGROUND = `
url("/assets/summary-background.svg") right center / auto 100% no-repeat,
linear-gradient(250.99deg, #BCDBFF -20.52%, #CFEAFF 109.18%)
`;

export const SummaryBox = ({ label, value, color = 'text.primary', decimals = 1, suffix = '%' }: SummaryBoxProps) => {
  return (
    <Box sx={{ borderRadius: '6px', backgroundColor: 'backdrops.transparentWhite', px: 2, py: 1.75 }}>
      <Typography component="p" variant="caption" sx={{ whiteSpace: 'nowrap', mb: 0.75 }}>
        {label}
      </Typography>
      <Typography variant={'h4'} component="span" sx={{ color: color, fontSize: '1.75rem', lineHeight: 1.2 }}>
        {value.format({ decimals })}
        {suffix}
      </Typography>
    </Box>
  );
};
